/**
 * Scroll-to-top button: shows after scrolling down, smooth scroll to top on click.
 */
export default class ScrollToTop {
  constructor(button) {
    if (!button) return;

    this._button = button;
    this._visibilityThreshold = 300;

    this._onScroll = this._onScroll.bind(this);
    this._onClick = this._onClick.bind(this);

    window.addEventListener('scroll', this._onScroll, { passive: true });
    this._button.addEventListener('click', this._onClick);

    this._onScroll();
  }

  _onScroll() {
    if (window.scrollY > this._visibilityThreshold) {
      this._button.classList.add('is-visible');
    } else {
      this._button.classList.remove('is-visible');
    }
  }

  _onClick() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
